import { useAuth } from "@/context/AuthContext";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel,
  DropdownMenuSeparator, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Building2, Check, ChevronDown, Globe } from "lucide-react";
import { cn } from "@/lib/utils";

export default function BranchSwitcher() {
  const { branches, activeBranch, setActiveBranch } = useAuth();
  const active = branches.find((b) => b.id === activeBranch);
  const label = activeBranch === "all" ? "All Branches" : active?.name || "All Branches";

  const options = [{ id: "all", name: "All Branches", type: "All" }, ...branches.filter((b) => b.is_active !== false)];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid="branch-switcher"
          className="flex items-center gap-2 rounded-lg border border-border bg-slate-50 px-3 py-1.5 text-sm font-medium text-secondary transition-colors hover:bg-slate-100"
        >
          <Building2 className="h-4 w-4 text-primary" />
          <span className="hidden max-w-[120px] truncate sm:inline">{label}</span>
          <ChevronDown className="h-3.5 w-3.5 text-muted-foreground" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-56">
        <DropdownMenuLabel>Active branch</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {options.map((b) => (
          <DropdownMenuItem
            key={b.id}
            data-testid={`branch-option-${b.id}`}
            onClick={() => setActiveBranch(b.id)}
            className="flex items-center gap-2"
          >
            {b.id === "all" ? <Globe className="h-4 w-4 text-muted-foreground" /> : <Building2 className="h-4 w-4 text-muted-foreground" />}
            <span className="flex-1 truncate">{b.name}</span>
            {b.id === activeBranch && <Check className={cn("h-4 w-4 text-primary")} />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
